import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../client/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_sentryserver_2329cbce from 'nuxt_plugin_sentryserver_2329cbce' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_ee9caede from 'nuxt_plugin_sentryclient_ee9caede' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_trustpilotplugin5ceefaeb_4e9cbab0 from 'nuxt_plugin_trustpilotplugin5ceefaeb_4e9cbab0' // Source: ./trustpilot.plugin.5ceefaeb.js (mode: 'all')
import nuxt_plugin_pluginutils_e3d638f4 from 'nuxt_plugin_pluginutils_e3d638f4' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_126aa751 from 'nuxt_plugin_pluginrouting_126aa751' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_0b6aedbe from 'nuxt_plugin_pluginmain_0b6aedbe' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_recaptcha_13525b44 from 'nuxt_plugin_recaptcha_13525b44' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_gtm_1442176b from 'nuxt_plugin_gtm_1442176b' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_vuescrollto_0c5a8d14 from 'nuxt_plugin_vuescrollto_0c5a8d14' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_portalvue_b9928bc4 from 'nuxt_plugin_portalvue_b9928bc4' // Source: ./portal-vue.js (mode: 'all')
import nuxt_plugin_nuxtsvgsprite_1401f433 from 'nuxt_plugin_nuxtsvgsprite_1401f433' // Source: ./nuxt-svg-sprite.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_9c9c5606 from 'nuxt_plugin_cookieuniversalnuxt_9c9c5606' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_gtm_5e4639ea from 'nuxt_plugin_gtm_5e4639ea' // Source: ../client/plugins/gtm (mode: 'client')
import nuxt_plugin_notifications_36de4932 from 'nuxt_plugin_notifications_36de4932' // Source: ../client/plugins/notifications (mode: 'all')
import nuxt_plugin_contextpath_bb87c00e from 'nuxt_plugin_contextpath_bb87c00e' // Source: ../client/plugins/context-path (mode: 'all')
import nuxt_plugin_clickoutside_5b0e3843 from 'nuxt_plugin_clickoutside_5b0e3843' // Source: ../client/plugins/click-outside.ts (mode: 'all')
import nuxt_plugin_auth_6a7e4e1e from 'nuxt_plugin_auth_6a7e4e1e' // Source: ../client/plugins/auth (mode: 'all')
import nuxt_plugin_breakpoints_0eed3a41 from 'nuxt_plugin_breakpoints_0eed3a41' // Source: ../client/plugins/breakpoints.ts (mode: 'all')
import nuxt_plugin_requestclient_c0c1dc82 from 'nuxt_plugin_requestclient_c0c1dc82' // Source: ../client/plugins/request-client (mode: 'all')
import nuxt_plugin_vuelidate_4be42f5c from 'nuxt_plugin_vuelidate_4be42f5c' // Source: ../client/plugins/vuelidate.ts (mode: 'all')
import nuxt_plugin_index_7347aa5b from 'nuxt_plugin_index_7347aa5b' // Source: ../client/plugins/error-handler/index.ts (mode: 'all')
import nuxt_plugin_contentful_cbbecb4c from 'nuxt_plugin_contentful_cbbecb4c' // Source: ../client/plugins/contentful (mode: 'all')
import nuxt_plugin_onlanguageswitched_3b511ca0 from 'nuxt_plugin_onlanguageswitched_3b511ca0' // Source: ../client/plugins/on-language-switched (mode: 'all')
import nuxt_plugin_lazyload_5fe1c4e9 from 'nuxt_plugin_lazyload_5fe1c4e9' // Source: ../client/plugins/lazy-load (mode: 'all')
import nuxt_plugin_currencyformatter_3022cc04 from 'nuxt_plugin_currencyformatter_3022cc04' // Source: ../client/plugins/currency-formatter (mode: 'all')
import nuxt_plugin_numberformatter_3e29d288 from 'nuxt_plugin_numberformatter_3e29d288' // Source: ../client/plugins/number-formatter (mode: 'all')
import nuxt_plugin_vuethemask_ab289cb6 from 'nuxt_plugin_vuethemask_ab289cb6' // Source: ../client/plugins/vue-the-mask (mode: 'client')
import nuxt_plugin_previewmode_0e6f2efe from 'nuxt_plugin_previewmode_0e6f2efe' // Source: ../client/plugins/preview-mode (mode: 'client')
import nuxt_plugin_localstoragerehydration_d61a7008 from 'nuxt_plugin_localstoragerehydration_d61a7008' // Source: ../client/plugins/localstorage-rehydration (mode: 'client')
import nuxt_plugin_vuescrolldrag_4ca7a792 from 'nuxt_plugin_vuescrolldrag_4ca7a792' // Source: ../client/plugins/vue-scroll-drag (mode: 'client')
import nuxt_plugin_extendedrouter_4726bc27 from 'nuxt_plugin_extendedrouter_4726bc27' // Source: ../client/plugins/extended-router (mode: 'client')
import nuxt_plugin_phraseapp_8866c3dc from 'nuxt_plugin_phraseapp_8866c3dc' // Source: ../client/plugins/phraseapp (mode: 'client')
import nuxt_plugin_datadogrum_72b4f259 from 'nuxt_plugin_datadogrum_72b4f259' // Source: ../client/plugins/datadog-rum (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"meta":[{"http-equiv":"Content-Type","content":"text\u002Fhtml","charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"href":"https:\u002F\u002Fuse.typekit.com\u002F","rel":"dns-prefetch"},{"href":"https:\u002F\u002Fuse.typekit.com","rel":"preconnect","crossorigin":"crossorigin"},{"href":"https:\u002F\u002Fuse.typekit.com\u002Ftlc5ckb.css","rel":"preload","as":"style"},{"href":"https:\u002F\u002Fuse.typekit.net\u002Fcgi0lwc.css","rel":"preload","as":"style"},{"href":"https:\u002F\u002Fuse.typekit.com\u002Ftlc5ckb.css","rel":"preload stylesheet","media":"print","onload":"this.media=\"all\""},{"href":"https:\u002F\u002Fuse.typekit.net\u002Fcgi0lwc.css","rel":"preload stylesheet","media":"print","onload":"this.media=\"all\""},{"href":"https:\u002F\u002Ffonts.googleapis.com","rel":"preconnect"},{"href":"https:\u002F\u002Ffonts.gstatic.com","rel":"preconnect","crossorigin":"crossorigin"},{"href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Poppins:wght@100&display=swap&text=%C2%AE","rel":"stylesheet"},{"href":"https:\u002F\u002Fb001.recharge.com","rel":"dns-prefetch"},{"href":"https:\u002F\u002Fb001.recharge.com","rel":"preconnect","crossorigin":"crossorigin"}],"script":[{"type":"text\u002Fjavascript","src":"https:\u002F\u002Fconsent.cookiebot.com\u002Fuc.js","id":"Cookiebot","data-cbid":"3ebac0e8-f20a-4620-b312-45258e88e6bf","data-blockingmode":"auto","async":true,"body":true},{"vmid":"bcChannelIdentifier","thirdPartyTag":"blueconic","innerHTML":"bcChannelIdentifier = \"uno.recharge.com\";","body":true},{"thirdPartyTag":"blueconic","src":"https:\u002F\u002Fb001.recharge.com\u002Fscript.js","defer":true,"body":true},{"type":"text\u002Fjavascript","src":"\u002F_nuxt\u002Fstatic\u002Ftrustpilot.js","defer":true,"body":true},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);}})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"__dangerouslyDisableSanitizersByTagID":{"bcChannelIdentifier":["innerHTML"],"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]},"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-PWWDDK7&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_2329cbce === 'function') {
    await nuxt_plugin_sentryserver_2329cbce(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_ee9caede === 'function') {
    await nuxt_plugin_sentryclient_ee9caede(app.context, inject)
  }

  if (typeof nuxt_plugin_trustpilotplugin5ceefaeb_4e9cbab0 === 'function') {
    await nuxt_plugin_trustpilotplugin5ceefaeb_4e9cbab0(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_e3d638f4 === 'function') {
    await nuxt_plugin_pluginutils_e3d638f4(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_126aa751 === 'function') {
    await nuxt_plugin_pluginrouting_126aa751(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_0b6aedbe === 'function') {
    await nuxt_plugin_pluginmain_0b6aedbe(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_13525b44 === 'function') {
    await nuxt_plugin_recaptcha_13525b44(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_1442176b === 'function') {
    await nuxt_plugin_gtm_1442176b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_0c5a8d14 === 'function') {
    await nuxt_plugin_vuescrollto_0c5a8d14(app.context, inject)
  }

  if (typeof nuxt_plugin_portalvue_b9928bc4 === 'function') {
    await nuxt_plugin_portalvue_b9928bc4(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtsvgsprite_1401f433 === 'function') {
    await nuxt_plugin_nuxtsvgsprite_1401f433(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_9c9c5606 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_9c9c5606(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtm_5e4639ea === 'function') {
    await nuxt_plugin_gtm_5e4639ea(app.context, inject)
  }

  if (typeof nuxt_plugin_notifications_36de4932 === 'function') {
    await nuxt_plugin_notifications_36de4932(app.context, inject)
  }

  if (typeof nuxt_plugin_contextpath_bb87c00e === 'function') {
    await nuxt_plugin_contextpath_bb87c00e(app.context, inject)
  }

  if (typeof nuxt_plugin_clickoutside_5b0e3843 === 'function') {
    await nuxt_plugin_clickoutside_5b0e3843(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_6a7e4e1e === 'function') {
    await nuxt_plugin_auth_6a7e4e1e(app.context, inject)
  }

  if (typeof nuxt_plugin_breakpoints_0eed3a41 === 'function') {
    await nuxt_plugin_breakpoints_0eed3a41(app.context, inject)
  }

  if (typeof nuxt_plugin_requestclient_c0c1dc82 === 'function') {
    await nuxt_plugin_requestclient_c0c1dc82(app.context, inject)
  }

  if (typeof nuxt_plugin_vuelidate_4be42f5c === 'function') {
    await nuxt_plugin_vuelidate_4be42f5c(app.context, inject)
  }

  if (typeof nuxt_plugin_index_7347aa5b === 'function') {
    await nuxt_plugin_index_7347aa5b(app.context, inject)
  }

  if (typeof nuxt_plugin_contentful_cbbecb4c === 'function') {
    await nuxt_plugin_contentful_cbbecb4c(app.context, inject)
  }

  if (typeof nuxt_plugin_onlanguageswitched_3b511ca0 === 'function') {
    await nuxt_plugin_onlanguageswitched_3b511ca0(app.context, inject)
  }

  if (typeof nuxt_plugin_lazyload_5fe1c4e9 === 'function') {
    await nuxt_plugin_lazyload_5fe1c4e9(app.context, inject)
  }

  if (typeof nuxt_plugin_currencyformatter_3022cc04 === 'function') {
    await nuxt_plugin_currencyformatter_3022cc04(app.context, inject)
  }

  if (typeof nuxt_plugin_numberformatter_3e29d288 === 'function') {
    await nuxt_plugin_numberformatter_3e29d288(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuethemask_ab289cb6 === 'function') {
    await nuxt_plugin_vuethemask_ab289cb6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_previewmode_0e6f2efe === 'function') {
    await nuxt_plugin_previewmode_0e6f2efe(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_localstoragerehydration_d61a7008 === 'function') {
    await nuxt_plugin_localstoragerehydration_d61a7008(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrolldrag_4ca7a792 === 'function') {
    await nuxt_plugin_vuescrolldrag_4ca7a792(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_extendedrouter_4726bc27 === 'function') {
    await nuxt_plugin_extendedrouter_4726bc27(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_phraseapp_8866c3dc === 'function') {
    await nuxt_plugin_phraseapp_8866c3dc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_datadogrum_72b4f259 === 'function') {
    await nuxt_plugin_datadogrum_72b4f259(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
